import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';

import {BaseComponent} from './base/base.component';
import {NavbarComponent} from './navbar/navbar.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {FooterComponent} from './footer/footer.component';
import {ChangePasswordDialogComponent} from './navbar/change-password-dialog/change-password-dialog.component';

import {ContentAnimateDirective} from '../../shared/content-animate/content-animate.directive';

import {NgbCollapseModule, NgbDropdownModule, NgbModalModule} from '@ng-bootstrap/ng-bootstrap';

import {FeahterIconModule} from '../../shared/feather-icon/feather-icon.module';

import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {SharedModule} from '../../shared/shared.module';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};

@NgModule({
    declarations: [BaseComponent, NavbarComponent, SidebarComponent, FooterComponent, ContentAnimateDirective,
        ChangePasswordDialogComponent],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        NgbDropdownModule,
        NgbCollapseModule,
        NgbModalModule,
        PerfectScrollbarModule,
        FeahterIconModule,
        SharedModule
    ],
    providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }
    ]
})
export class LayoutModule {
}
